export enum NotificationStatus {
  ARCHIVED = 'ARCHIVED',
  DELIVERED = 'DELIVERED',
  NEW = 'NEW',
  READ = 'READ',
  UNREAD = 'UNREAD',
}

export enum NotificationAction {
  OPEN_CARE_TEAM = 'OPEN_CARE_TEAM',
  OPEN_CHAT = 'OPEN_CHAT',
  OPEN_INQUIRY = 'OPEN_INQUIRY',
  OPEN_PATIENT_PROFILE = 'OPEN_PATIENT_PROFILE',
  OPEN_PATIENT_NOTE = 'OPEN_PATIENT_NOTE',
}

export enum NotificationEventType {
  ADDED_TO_CARE_TEAM = 'ADDED_TO_CARE_TEAM',
  ASSIGNED_INQUIRY = 'ASSIGNED_INQUIRY',
  CHAT_MENTION = 'CHAT_MENTION',
  CHAT_MESSAGE = 'CHAT_MESSAGE',
  CHAT_REPLY = 'CHAT_REPLY',
  COMPLETED_INTAKE_SURVEY = 'COMPLETED_INTAKE_SURVEY',
  INQUIRY_STATUS_CHANGE = 'INQUIRY_STATUS_CHANGE',
  INSURANCE_STATUS_CHANGE = 'INSURANCE_STATUS_CHANGE',
  MEDICAL_CLEARANCE_STATUS_CHANGE = 'MEDICAL_CLEARANCE_STATUS_CHANGE',
  REMOVED_FROM_CARE_TEAM = 'REMOVED_FROM_CARE_TEAM',
  TARGET_ADMIT_DATE_CHANGE = 'TARGET_ADMIT_DATE_CHANGE',
  UPDATED_ADMIN_EPISODE = 'UPDATED_ADMIN_EPISODE',
  UPDATED_CONTACTS = 'UPDATED_CONTACTS',
  UPDATED_INSURANCE_STATUS = 'UPDATED_INSURANCE_STATUS',
  UPDATED_MEDICAL_CLEARANCE_STATUS = 'UPDATED_MEDICAL_CLEARANCE_STATUS',
  UPLOADED_INSURANCE_CARD = 'UPLOADED_INSURANCE_CARD',
}

export const notificationActionToMaudPathMapper: Record<
  NotificationAction,
  string
> = {
  [NotificationAction.OPEN_CHAT]: 'messages',
  [NotificationAction.OPEN_CARE_TEAM]: 'care-planning',
  [NotificationAction.OPEN_INQUIRY]: 'inquiries',
  [NotificationAction.OPEN_PATIENT_PROFILE]: 'overview',
  [NotificationAction.OPEN_PATIENT_NOTE]: 'notes',
};

export const NEW_REPLIES = 'New Replies';
export const NEW_MENTIONS = 'New Mentions';
export const NEW_MESSAGES = 'New Messages';
export const READ_REPLIES = 'Read Replies';
export const READ_MENTIONS = 'Read Mentions';
export const READ_MESSAGES = 'Read Messages';

export const NOTIFICATION_HEADER_STYLES: Record<string, string> = {
  lineHeight: '16.8px',
  paddingLeft: '8px',
  paddingRight: '8px',
};
